import { render, staticRenderFns } from "./AbkOffersBox.vue?vue&type=template&id=40f1e7e1&scoped=true&"
import script from "./AbkOffersBox.vue?vue&type=script&lang=js&"
export * from "./AbkOffersBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkOffersBox.vue?vue&type=style&index=0&id=40f1e7e1&scoped=true&lang=scss&"
import style1 from "./AbkOffersBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1e7e1",
  null
  
)

export default component.exports